import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Business Partner Cell Renderer
 * Muestra código y nombre del socio de negocio en formato vertical
 */
@Component({
  selector: 'app-business-partner-lost-sale-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col gap-1">
      <span class="text-sm font-semibold text-gray-600 dark:text-gray-300">{{ code }}</span>
      <span class="text-sm">{{ name }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class BusinessPartnerLostSalesCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  get code(): string {
    return this.params?.data?.shipToExternalKeyCode ?? '-';
  }

  get name(): string {
    return this.params?.data?.shipToName ?? '-';
  }
}
